<div
  class="empty-state"
  [class.empty-state--small]="icon()"
  [class.empty-state--inline]="inline()"
  [class.empty-state--transparent]="transparent()"
>
  @if (icon(); as icn) {
    <ftr-icon [icon]="icn" color="GreyLight" [size]="iconSize()" align="Middle"></ftr-icon>
  } @else {
    @if (illustration(); as illustr) {
      <ftr-illustration [illustration]="illustr" [attr.aria-hidden]="true"></ftr-illustration>
    }
  }
  @if (displayTitle(); as dTitle) {
    <p class="empty-state__title">{{ dTitle }}</p>
  }
  <p>
    @if (messageTemplate(); as msgTpl) {
      <ng-container *ngTemplateOutlet="msgTpl"></ng-container>
    } @else if (message()) {
      {{ message() }}
    }
  </p>
</div>
